var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.slides.length
    ? _c(
        "div",
        [
          _c(
            "VueSlickCarousel",
            {
              staticClass: "announcement-ticker",
              attrs: {
                arrows: false,
                dots: false,
                adaptiveHeight: false,
                autoplay: true,
                autoplaySpeed: 4000,
              },
            },
            _vm._l(_vm.slides, function (slide) {
              return _c(
                "div",
                { key: slide.id, style: { backgroundColor: slide.color } },
                [_vm._v("\n            " + _vm._s(slide.desc) + "\n        ")]
              )
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }